import React, { useContext, useState, createContext } from 'react';
import { useSnackbar } from 'notistack';

export const DockerManagementContext = createContext({ state: {}, actions: {} });

const DockerManagementProvider = ({ children }) => {
	const [modes, setModes] = useState([]);
	const [chipsets, setChipsets] = useState([]);
	const [availableComposes, setAvailableComposes] = useState([]);
	const [configuredComposes, setConfiguredComposes] = useState([]);
	const [editObj, setEditObj] = useState(null);
	const [deleteObj, setDeleteObj] = useState(null);
	const [devicesInfoObj, setDevicesInfoObj] = useState(null);

	//TODO Implement this. There will need to be some sort of interface for this and I think we will want it to be a full refresh page with targets
	//Leaving in pending discussion
	const [refreshObj, setRefreshObj] = useState(null);
	const { enqueueSnackbar } = useSnackbar();

	const value = {
		state: {
			modes,
			chipsets,
			availableComposes,
			configuredComposes,
			editObj,
			devicesInfoObj,
			deleteObj,
		},
		actions: {
			setAvailableComposes,
			setConfiguration: (responseData) => {
				setModes(responseData.deviceModes);
				setChipsets(responseData.deviceChipsets);
				setAvailableComposes(responseData.availableComposes);
				setConfiguredComposes(responseData.configuredMappings.sort((a, b) => a.id - b.id));
			},
			showError: (msg) => {
				enqueueSnackbar(msg, { variant: "error" });
			},
			addClick: () => {
				setEditObj({
					useDeviceIds: false, // Default to chipset/mode selection
					chipset: 0,
					mode: 0,
					yamlFile: "",
					active: true,
					deviceIds: [],
				});
			},
			editClick: (id) => {
				const selectedConfig = configuredComposes.find((x) => x.id === id);
				if (selectedConfig) {
					setEditObj({
						...selectedConfig,
						useDeviceIds: Array.isArray(selectedConfig.deviceIds),
						deviceIds: Array.isArray(selectedConfig.deviceIds)
							? selectedConfig.deviceIds.map((id) => ({ deviceId: id }))
							: [],
					});
				}
			},
			editTabSwitch: (useDeviceIds) => {
				setEditObj((prev) => ({
					...prev,
					useDeviceIds,
					chipset: useDeviceIds ? null : 0,
					mode: useDeviceIds ? null : 0,
					deviceIds: useDeviceIds ? [] : null, // Always keep deviceIds as an array
				}));
			},
			cancelEdit: () => {
				setEditObj(null);
			},
			addNewConfiguration: (newValueObj) => {
				setConfiguredComposes([...configuredComposes, newValueObj].sort((a, b) => a.id - b.id));
			},
			updateConfiguration: (newValueObj) => {
				setConfiguredComposes(
					configuredComposes
						.map((obj) => (obj.id === newValueObj.id ? newValueObj : obj))
						.sort((a, b) => a.id - b.id)
				);
			},
			deleteClick: (id) => {
				setDeleteObj(configuredComposes.find((x) => x.id === id));
			},
			cancelDelete: () => {
				setDeleteObj(null);
			},

			displayDevices: (id) => {
				setDevicesInfoObj(configuredComposes.find((x) => x.id === id));
			},
			closeDisplayDevices: () => {
				setDevicesInfoObj(null);
			},
			removeConfigurationFromList: (id) => {
				setConfiguredComposes(configuredComposes.filter((x) => x.id !== id));
			},
			getModeNameFromModeId: (typeId) => {
				return typeId === null ? null : modes?.find((t) => t.id === typeId)?.name;
			},
			getChipsetNameFromModeId: (typeId) => {
				return typeId === null ? null : chipsets?.find((t) => t.id === typeId)?.name;
			},
			promptRefresh: () => {
				setRefreshObj(true);
			},
			resetRefresh: () => {
				setRefreshObj(false);
			},
		},
	};

	return (
		<DockerManagementContext.Provider value={value}>
			{children}
		</DockerManagementContext.Provider>
	);
};

export default DockerManagementProvider;

export function useDockerManagementContext() {
	return useContext(DockerManagementContext);
}
